module.exports = __webpack_public_path__ + "img/brightness_high.6dd6df55.svg";